document.addEventListener("DOMContentLoaded", () => {
    // ------- DOM refs -------
    const headerBar = document.querySelector("header");
    const navbar = document.querySelector(".navbar");

    const searchIcon = document.querySelector(".navbar__icon--search");
    const userIcon = document.querySelector(".navbar__icon--user");
    const cartIcon = document.querySelector(".navbar__icon--cart");

    const searchPanel = document.querySelector(".navbar__search");
    const userMenu = document.querySelector(".navbar__user-menu");
    const cartMenu = document.querySelector(".navbar__cart"); // matches your HTML

    const mobileToggle = document.getElementById("mobileMenuToggle");
    const navMenu = document.querySelector(".navbar__menu");

    const productsTrigger = document.getElementById("productsMegaMenu");
    const productsControl = productsTrigger
        ? productsTrigger.querySelector("button, a")
        : null;
    const megaMenu = document.querySelector(".productsMegaMenu");

    // ------- helpers -------
    const isHoverDevice = () =>
        window.matchMedia("(hover: hover) and (pointer: fine)").matches;
    const isMobileLike = () =>
        !isHoverDevice() || window.matchMedia("(max-width: 1024px)").matches;

    // Scroll lock (for mobile menu / mega menu)
    const ScrollLock = (() => {
        let locked = false;
        let lastY = 0;
        const sbw = () => window.innerWidth - document.documentElement.clientWidth;

        const lock = () => {
            if (locked) return;
            locked = true;
            lastY = window.scrollY || document.documentElement.scrollTop || 0;
            const w = sbw();
            if (w > 0) document.body.style.paddingRight = `${w}px`;
            document.body.style.top = `-${lastY}px`;
            document.body.classList.add("scroll-lock");
        };

        const unlock = () => {
            if (!locked) return;
            locked = false;
            document.body.classList.remove("scroll-lock");
            document.body.style.paddingRight = "";
            const y = lastY;
            document.body.style.top = "";
            window.scrollTo(0, y);
        };

        return { ensure: (should) => (should ? lock() : unlock()) };
    })();

    const isAnyMenuOpen = () =>
        navMenu?.classList.contains("is-open") ||
        megaMenu?.classList.contains("is-open");

    // lock only on touch/mobile; never on desktop hover (prevents “jump”)
    const syncScrollLock = () => {
        if (!isHoverDevice()) {
            ScrollLock.ensure(isAnyMenuOpen());
        } else {
            ScrollLock.ensure(false);
        }
    };

    const setExpandedProducts = (on) => {
        if (!productsControl) return;
        productsControl.setAttribute("aria-haspopup", "true");
        productsControl.setAttribute("aria-expanded", on ? "true" : "false");
    };

    // Helper: close search panel + reset icon state
    const closeSearchPanel = () => {
        navbar?.classList.remove("navbar--search-active");
        if (searchIcon) {
            searchIcon.classList.remove("is-active");
            searchIcon.setAttribute("aria-label", "Search");
        }
    };

    // >>> CLASS TOGGLING ON HEADER FOR MEGA <<<
    let headerWasStickyBeforeMega = false;

    const openMega = () => {
        if (!megaMenu) return;

        // Remember current sticky state before we change anything
        headerWasStickyBeforeMega = !!headerBar?.classList.contains("sticky");

        megaMenu.classList.add("is-open");
        setExpandedProducts(true);

        // Header class management
        headerBar?.classList.add("stickyMegaMenu");
        headerBar?.classList.remove("sticky");

        syncScrollLock();
    };

    const closeMega = () => {
        if (!megaMenu) return;
        megaMenu.classList.remove("is-open");
        setExpandedProducts(false);

        // Header class management
        headerBar?.classList.remove("stickyMegaMenu");

        // Only restore .sticky if it was present before opening mega
        if (headerWasStickyBeforeMega) {
            headerBar?.classList.add("sticky");
        } else {
            headerBar?.classList.remove("sticky");
        }

        syncScrollLock();
    };

    const toggleNavMenu = (forceOpen) => {
        if (!navMenu) return;
        const open =
            typeof forceOpen === "boolean"
                ? forceOpen
                : !navMenu.classList.contains("is-open");
        navMenu.classList.toggle("is-open", open);
        navbar?.classList.toggle("navbar--mobile-open", open);
        mobileToggle?.setAttribute("aria-expanded", open ? "true" : "false");
        if (!open) closeMega(); // closing main menu also closes mega
        syncScrollLock();
    };

    const forceCloseMainMenus = () => {
        if (navMenu?.classList.contains("is-open")) {
            navMenu.classList.remove("is-open");
            navbar?.classList.remove("navbar--mobile-open");
            mobileToggle?.setAttribute("aria-expanded", "false");
        }
        if (megaMenu?.classList.contains("is-open")) {
            closeMega();
        } else {
            syncScrollLock();
        }
    };

    const closeAllPanelsExcept = (keep) => {
        if (keep !== "search") closeSearchPanel();
        if (keep !== "user") userMenu?.classList.remove("open");
        if (keep !== "cart") cartMenu?.classList.remove("open");
    };

    // Protect from accidental navigation if someone uses <a>
    if (productsControl && productsControl.tagName === "A") {
        const stopNav = (e) => e.preventDefault();
        productsControl.addEventListener("click", stopNav);
        productsControl.addEventListener("pointerdown", stopNav);
    }

    // ------- Search / User toggles -------
    if (searchIcon) {
        searchIcon.addEventListener("click", (e) => {
            e.preventDefault();

            const isActive = navbar?.classList.contains("navbar--search-active");
            const willOpen = !isActive;

            if (willOpen) {
                // Open search
                closeAllPanelsExcept("search");
                if (isMobileLike()) forceCloseMainMenus();
                navbar?.classList.add("navbar--search-active");
                searchPanel?.querySelector("input")?.focus();

                searchIcon.classList.add("is-active");
                searchIcon.setAttribute("aria-label", "Close search");
            } else {
                // Close search
                closeSearchPanel();
            }
        });
    }

    if (userIcon) {
        userIcon.addEventListener("click", (e) => {
            e.preventDefault();
            const willOpen = !userMenu?.classList.contains("open");
            closeAllPanelsExcept("user");
            if (isMobileLike()) forceCloseMainMenus();
            if (willOpen) userMenu?.classList.add("open");
        });
    }

    // ------- Cart (dialog-like) -------
    if (cartMenu) {
        cartMenu.setAttribute("role", "dialog");
        cartMenu.setAttribute("aria-modal", "true");
        cartMenu.setAttribute("aria-hidden", "true");
        if (!cartMenu.hasAttribute("tabindex"))
            cartMenu.setAttribute("tabindex", "-1");
        if (!cartMenu.id) cartMenu.id = "navbarCartMenu";
    }
    if (cartIcon && cartMenu) {
        cartIcon.setAttribute("aria-controls", cartMenu.id);
        cartIcon.setAttribute("aria-expanded", "false");
    }

    const CART_LOCKS_SCROLL = false;
    let lastFocusedBeforeCart = null;

    const openCart = async () => {
        if (!cartMenu) return;
        $(".navbar__cart").html(await ajaxDynamicMethod($(cartIcon).data("href"), "GET"));
        applyTheme();
        closeAllPanelsExcept("cart");
        if (isMobileLike()) forceCloseMainMenus();
        lastFocusedBeforeCart = document.activeElement;
        cartMenu.classList.add("open");
        cartIcon?.setAttribute("aria-expanded", "true");
        cartMenu.setAttribute("aria-hidden", "false");

        if (CART_LOCKS_SCROLL) ScrollLock.ensure(true);

        const focusable = cartMenu.querySelector(
            'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
        );
        (focusable || cartMenu).focus({ preventScroll: true });

        if ($('meta[name="current-route"]').attr("content") == "order.make.payment") {
            $(".navbar__cartMenuContent").find("input, button").prop("disabled", true);
        }
    };

    const closeCart = () => {
        if (!cartMenu) return;
        cartMenu.classList.remove("open");
        cartIcon?.setAttribute("aria-expanded", "false");
        cartMenu.setAttribute("aria-hidden", "true");
        if (CART_LOCKS_SCROLL) ScrollLock.ensure(isAnyMenuOpen());

        if (
            lastFocusedBeforeCart &&
            document.body.contains(lastFocusedBeforeCart)
        ) {
            lastFocusedBeforeCart.focus({ preventScroll: true });
        } else {
            cartIcon?.focus({ preventScroll: true });
        }
    };

    const toggleCart = () => {
        if (!cartMenu) return;
        cartMenu.classList.contains("open") ? closeCart() : openCart();
    };

    if (cartIcon) {
        cartIcon.addEventListener("click", (e) => {
            e.preventDefault();
            toggleCart();
        });
    }

    if (cartMenu) {
        cartMenu.addEventListener("click", (e) => {
            const trigger = e.target.closest("#closeCartMenu, .closeCartMenu");
            if (trigger && cartMenu.classList.contains("open")) {
                e.preventDefault();
                closeCart();
            }
        });
    }

    document.addEventListener("keydown", (e) => {
        if (
            (e.key === "Enter" || e.key === " ") &&
            cartMenu?.classList.contains("open")
        ) {
            const trigger = e.target.closest("#closeCartMenu, .closeCartMenu");
            if (trigger) {
                e.preventDefault();
                closeCart();
            }
        }
    });

    document.addEventListener("keydown", (e) => {
        if (e.key !== "Escape") return;

        // If search is open, close just the search and exit
        if (navbar?.classList.contains("navbar--search-active")) {
            closeSearchPanel();
            return;
        }

        // Otherwise fall back to global close behavior
        userMenu?.classList.remove("open");
        if (cartMenu?.classList.contains("open")) closeCart();
        navMenu?.classList.remove("is-open");
        navbar?.classList.remove("navbar--mobile-open");
        closeMega();
        syncScrollLock();
    });

    document.addEventListener("pointerdown", (e) => {
        if (!cartMenu?.classList.contains("open")) return;
        const isDeleteBtn = !!e.target.closest(".cartItem");
        const isSwalContainer = !!e.target.closest(".swal2-container");
        const isSwalModal = !!e.target.closest(".swal2-modal");
        const isSwalOverlay = e.target.classList.contains("swal2-overlay");

        const isSweetAlertClick =
            isDeleteBtn || isSwalContainer || isSwalModal || isSwalOverlay;

        if (isSweetAlertClick) {
            return; // Do NOT close cart
        }
        const clickInsideCart = cartMenu.contains(e.target);
        const clickOnTrigger =
            cartIcon && (e.target === cartIcon || cartIcon.contains(e.target));
        if (!clickInsideCart && !clickOnTrigger) closeCart();
    });

    // ------- Mobile Navbar toggles -------
    if (mobileToggle && navMenu) {
        if (!navMenu.id) navMenu.id = "navbarMenu";
        mobileToggle.setAttribute("aria-controls", navMenu.id);
        mobileToggle.setAttribute("aria-expanded", "false");
        mobileToggle.addEventListener("click", (e) => {
            e.preventDefault();
            toggleNavMenu();
            if (navMenu?.classList.contains("is-open")) closeAllPanelsExcept(null);
        });
    }

    // ------- Products Mega: desktop hover, mobile tap -------
    if (productsTrigger && megaMenu) {
        const toggleMegaMobile = (e) => {
            if (isHoverDevice()) return; // desktop uses hover
            e?.preventDefault();
            if (megaMenu.classList.contains("is-open")) {
                closeMega();
            } else {
                openMega();
            }
            if (megaMenu.classList.contains("is-open")) closeAllPanelsExcept(null);
        };

        // Desktop hover
        let hoverInside = false;
        let closeTimer = null;
        const scheduleClose = () => {
            clearTimeout(closeTimer);
            closeTimer = setTimeout(() => {
                if (!hoverInside) closeMega();
            }, 120);
        };
        const onEnter = () => {
            if (!isHoverDevice()) return;
            hoverInside = true;
            clearTimeout(closeTimer);
            openMega();
            closeAllPanelsExcept(null);
        };
        const onLeave = () => {
            if (!isHoverDevice()) return;
            hoverInside = false;
            scheduleClose();
        };

        productsTrigger.addEventListener("mouseenter", onEnter);
        productsTrigger.addEventListener("mouseleave", onLeave);
        megaMenu.addEventListener("mouseenter", onEnter);
        megaMenu.addEventListener("mouseleave", onLeave);

        productsControl?.addEventListener("focus", onEnter);
        productsControl?.addEventListener("blur", onLeave);

        // Mobile tap/click
        productsTrigger.addEventListener("click", toggleMegaMobile, {
            passive: false,
        });
        productsControl?.addEventListener("click", toggleMegaMobile, {
            passive: false,
        });
        productsTrigger.addEventListener("touchend", toggleMegaMobile, {
            passive: false,
        });

        // Back button inside mega
        document.addEventListener("click", (e) => {
            const backBtn = e.target.closest(".menuBack");
            if (backBtn && megaMenu.classList.contains("is-open")) closeMega();
        });

        // Outside close
        document.addEventListener("pointerdown", (e) => {
            if (
                megaMenu.classList.contains("is-open") &&
                !megaMenu.contains(e.target) &&
                !productsTrigger.contains(e.target)
            ) {
                closeMega();
            }
        });
    }

    // ------- Close small panels on outside click -------
    document.addEventListener("click", (e) => {
        if (!navbar) return;


        const isSwalContainer = !!e.target.closest(".swal2-container");
        const isSwalModal = !!e.target.closest(".swal2-modal");
        const isSwalOverlay = e.target.classList.contains("swal2-overlay");

        if (isSwalContainer || isSwalModal || isSwalOverlay) {
            return; // DO NOT close cart
        }

        const insideNavbar = navbar.contains(e.target);
        const insideCart = cartMenu?.contains(e.target);
        const insideUser = userMenu?.contains(e.target);
        const insideSearch = searchPanel?.contains(e.target);
        const insideMega = megaMenu?.contains(e.target);

        const insideAnyPanel =
            insideNavbar ||
            insideCart ||
            insideUser ||
            insideSearch ||
            insideMega;

        if (!insideAnyPanel) {
            closeSearchPanel();
            userMenu?.classList.remove("open");
            cartMenu?.classList.remove("open");
        }
    });

    // ------- Sticky header + close search on page scroll -------
    if (headerBar) {
        const onScroll = () => {
            // If search is open and the main page scrolls, close it
            if (navbar?.classList.contains("navbar--search-active")) {
                closeSearchPanel();
            }

            if (window.scrollY > 0) headerBar.classList.add("sticky");
            else headerBar.classList.remove("sticky");

            // If mega menu is open, force stickyMegaMenu to take precedence
            if (megaMenu?.classList.contains("is-open")) {
                headerBar.classList.add("stickyMegaMenu");
                headerBar.classList.remove("sticky");
            }
        };
        window.addEventListener("scroll", onScroll, { passive: true });
        onScroll();
    }

    // ------- keep scroll lock in sync on pointer-capability change -------
    const mq = window.matchMedia("(hover: hover) and (pointer: fine)");
    mq.addEventListener?.("change", () => syncScrollLock());
});

// Standalone burger button visual toggle (your SVG button)
document.addEventListener("click", (e) => {
    const btn = e.target.closest(".burger");
    if (!btn) return;
    const isOpen = btn.getAttribute("data-state") === "open";
    btn.setAttribute("data-state", isOpen ? "closed" : "open");
    btn.setAttribute("aria-expanded", String(!isOpen));
    btn.setAttribute("aria-label", isOpen ? "Open menu" : "Close menu");
});
